// THE CALENDAR'S OWN BOOKING FORM IN AN AI ANSWER (workspace functions/
// assistantAppForms.js). The assistant proposes an event — a new meeting, or
// an existing event moved to another day and time. The answer's "Review and
// save" calls calendarAiFormOpen, which opens the calendar's own booking sheet
// (CalNewBookingModal through openNewBookingModal) seeded with the proposal.
// Nothing is written until the member saves in the sheet; saveEvent then
// reports the saved event back (the draft's `aiRequest`), so the answer shows
// it as a row that opens the event.

export function calendarAiForms() {
  return {
    app: {
      id: 'system/calendar',
      navbar: [{ label: 'shell.app.calendar', route: '/calendar', icon: 'date outline' }],
      apps: [{ icon: 'date outline' }]
    },
    forms: [
      {
        id: 'calendar-event',
        title: 'calendar.aiForm.title',
        describe:
          'Create a calendar event, or move / edit one (recordId = the event id): title, date, start, end, invitees, description.',
        open: 'calendarAiFormOpen',
        fields: {
          title: { type: 'string', label: 'calendar.aiForm.field.title' },
          date: { type: 'date', label: 'calendar.aiForm.field.date' },
          startTime: { type: 'string', describe: 'HH:MM', label: 'calendar.aiForm.field.start' },
          endTime: { type: 'string', describe: 'HH:MM', label: 'calendar.aiForm.field.end' },
          invitees: {
            type: 'string',
            describe: 'emails, comma separated',
            label: 'calendar.aiForm.field.invitees'
          },
          description: { type: 'string', label: 'calendar.aiForm.field.description' }
        }
      }
    ]
  }
}

// (formId, { values, recordId, requestId }) → true when a sheet opened.
// With a recordId: the event's own fields (its recurrence inferred the way
// the detail sheet's Edit does), the proposal over them — for the person who
// may write the event (calendarCanWriteEvent: its organizer, compared
// without case, or a platform superadmin; the server's rule). Anyone else
// gets the read-only detail instead: an edit sheet whose Save the server
// refuses could only fail. Without a recordId: a new booking with the
// proposal.
export function calendarAiFormOpen(formId, args) {
  const el = this
  if (formId !== 'calendar-event') return false
  const root = el.state && el.state.root
  if (!root) return false
  const a = args && typeof args === 'object' ? args : {}
  const v = a.values && typeof a.values === 'object' ? a.values : {}
  const patch = {}
  for (const k of ['title', 'date', 'startTime', 'endTime', 'description']) {
    if (v[k] != null && v[k] !== '') patch[k] = String(v[k])
  }
  if (v.invitees != null && v.invitees !== '') {
    patch.invitees = Array.isArray(v.invitees) ? v.invitees.join(', ') : String(v.invitees)
  }
  const aiRequest = a.requestId ? String(a.requestId) : null
  if (a.recordId != null && a.recordId !== '') {
    const ev = (root.events || []).find((x) => x && String(x.id) === String(a.recordId))
    if (!ev) return false
    if (el.call('calendarCanWriteEvent', ev, root) !== true) {
      el.call('openEventDetailModal', ev)
      return true
    }
    const inferred = el.call('inferRecurrence', root.events, ev) || {}
    const booking = el.call('freshBooking', {
      title: ev.title || '',
      date: ev.date,
      startTime: ev.startTime,
      endTime: ev.endTime,
      invitees: (ev.invitees || []).join(', '),
      description: ev.description || '',
      type: ev.type || 'meeting',
      meetingMode: ev.meetingMode || 'symbols-meet',
      meetUrl: ev.meetUrl || '',
      recurring: inferred.recurring || 'none',
      recurringDays: inferred.recurringDays || [],
      recurrenceEndType: ev.recurrenceEndType || 'after',
      recurrenceEndCount: ev.recurrenceEndCount || 10,
      recurrenceEndDate: ev.recurrenceEndDate || '',
      integrationMetadata: ev.integrationMetadata,
      reminderMinutes: ev.reminderMinutes ?? null,
      editingEventId: ev.id,
      ...patch,
      aiRequest
    })
    el.call('openNewBookingModal', { __booking: booking })
    return true
  }
  el.call('openNewBookingModal', { ...patch, aiRequest })
  return true
}
